import { render } from "./Role.vue?vue&type=template&id=1dbc63e9&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=1dbc63e9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1dbc63e9"

export default script